export default __webpack_public_path__ + "static/media/match-wordmark.24ed28ac.svg";